import Vue from "vue";
import App from "./App.vue";
import router from "./router";
// import OSS from './plugins/oss'
import store from "./store";
//引入请求
import request from "./api/index"; //请求
//全局引用Element ui
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
//引入vueI18处理语言切换
import VueI18n from "vue-i18n";
//引入element处理语言
import ElementLocale from "element-ui/lib/locale";
import enLocale from "element-ui/lib/locale/lang/en";
import zhLocale from "element-ui/lib/locale/lang/zh-CN";
import vnLocale from "element-ui/lib/locale/lang/vi";
import CN from "@/languages/Chinese";
import VI from "@/languages/Vietnam";
import MY from "@/languages/Myanmar";
import MS from "@/languages/Malaysia";
import myLocale from "@/languages/myanmar-locale-element-ui"
// import EN from "@/languages/English"
//改变Element的主题颜色
import "./assets/style/element-variables.scss";
//引入ECharts制作数据可视化
import * as echarts from "echarts";
//封装函数，全局挂载到Vue示例上
import dataConversion from "@/plugins/dataConversion";
// 多选查询数据转换
import MultipleQuery from "@/plugins/MultipleQuery";
//导入复制文本方法
import copy from "./plugins/copyText";
//导入条形码插件
import VueBarcode from "vue-barcode";
//引入修改鼠标右键事件
import Contextmenu from "v-contextmenu-directive";
// 封装权限按钮函数，全局挂载到Vue实例上
import getPermissionButton from "@/plugins/getPermissionButton";
// 指令判断按钮权限
import {
  hasPermission,
  judgeButtonPermission,
} from "@/plugins/buttonPermission";
// 页面跳转事件
import {
  getRouteName,
  returnToParentAfterCompletingOperation,
  childrenPageOpen,
  resetToInitialData,
  createBus,
  destroyBus,
  deepClone,
  generateKey,
  judgeCurrentRouteStyle,
} from "@/plugins/childrenPage";
// 表格字段处理
import {
  deleteWidth,
  insertEmptyObject,
  processCustomFieldConfig,
  getFields,
  getFieldName,
} from "@/plugins/fieldList";
// 表格高度计算
import {
  addResizeListenerForCalculateTableHeight,
  removeResizeListenerForCalculateTableHeight,
  calculateTableHeight,
} from "@/plugins/calculateTableHeight";
import { environment, getEnvironmentAssets } from "@/plugins/environment"; // 引入环境变量
// 数字限制指令
import numberLimit from "@/plugins/numberLimit"; // 引入数字限制指令

// 根据环境设置标题和图标
const setEnvironmentAssets = () => {
  // 设置页面标题
  document.title = getEnvironmentAssets("title");

  // 设置favicon
  const favicon = document.querySelector('link[rel="icon"]');
  if (favicon) {
    favicon.href = getEnvironmentAssets("favicon");
  }
};
setEnvironmentAssets();
import { doExport } from "@/plugins/openExportListData"; // 导出
Vue.config.productionTip = false;
Vue.prototype.$echarts = echarts;
Vue.use(ElementUI, { size: "mini " }); //elementUI默认大小为mini
Vue.use(VueI18n);
Vue.use(request);
Vue.use(dataConversion);
Vue.use(MultipleQuery);
Vue.use(copy);
Vue.use(getPermissionButton);
Vue.use(Contextmenu);
Vue.component("barcode", VueBarcode);
Vue.use(hasPermission);
Vue.use(numberLimit);

Vue.prototype.$getRouteName = getRouteName;
Vue.prototype.$returnToParentAfterCompletingOperation =
  returnToParentAfterCompletingOperation;
Vue.prototype.$childrenPageOpen = childrenPageOpen;
Vue.prototype.$resetToInitialData = resetToInitialData;
Vue.prototype.$createBus = createBus;
Vue.prototype.$destroyBus = destroyBus;
Vue.prototype.$deepClone = deepClone;
Vue.prototype.$generateKey = generateKey;
Vue.prototype.$judgeCurrentRouteStyle = judgeCurrentRouteStyle;
Vue.prototype.$deleteWidth = deleteWidth;
Vue.prototype.$insertEmptyObject = insertEmptyObject;
Vue.prototype.$processCustomFieldConfig = processCustomFieldConfig;
Vue.prototype.$getFields = getFields;
Vue.prototype.$getFieldName = getFieldName;
Vue.prototype.$addResizeListenerForCalculateTableHeight =
  addResizeListenerForCalculateTableHeight;
Vue.prototype.$removeResizeListenerForCalculateTableHeight =
  removeResizeListenerForCalculateTableHeight;
Vue.prototype.$calculateTableHeight = calculateTableHeight;
Vue.prototype.$judgeButtonPermission = judgeButtonPermission;
Vue.prototype.$environment = environment;
Vue.prototype.$doExport = doExport;

//此处将CN中所有下划线替换为空格使用
let newCN = {};
for (var key in CN) {
  newCN[key] = key.replace(/_/g, " ");
}
// console.log(newCN);
export const i18n = new VueI18n({
  locale: localStorage.getItem("OMS-local") || "zh",
  messages: {
    zh: {
      ...zhLocale, //elementui中文包
      ...CN,
    },
    en: {
      ...enLocale, //elementui英文包
      ...newCN,
    },
    vi: {
      ...vnLocale, //elementui越南文包
      ...VI,
    },
    my: {
      ...myLocale, //elementui缅甸文包
     ...MY,
    },
    ms: {
     ...MS,
    },
  },
  silentTranslationWarn: true,
});
ElementLocale.i18n((key, value) => i18n.t(key, value));
new Vue({
  i18n,
  router,
  // OSS,
  store,
  echarts,
  render: (h) => h(App),
}).$mount("#app");
